"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.0118 11.6089c.5288 0 .9575-.43.9575-.9605 0-.5304-.4287-.9604-.9575-.9604-.5288 0-.9575.43-.9575.9604 0 .5305.4287.9605.9575.9605z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7166 5.8335c0 .7714.3025 1.4719.795 1.9885C7.7453 9.2075 5.4743 13.473 4 16.24L13.0394 22v-1.5324c1.6284.4429 3.3449-.8296 3.3449-2.551 0-1.3897-.9788-2.4627-1.7099-3.4313 1.2099.0076 2.9181-.0208 4.3256-.0208l-2.0788-3.4772c.1842-1.082-.075-2.1343-.6424-3.0003a2.8744 2.8744 0 0 0 .9657-2.1535c0-1.5063-1.1533-2.7422-2.6219-2.8668C14.0977 2.3737 13.3321 2 12.4796 2c-.8527 0-1.6183.3737-2.1432.9669-1.4676.1256-2.6198 1.361-2.6198 2.8666zm2.8667-.9551c-.5256 0-.9517.4276-.9517.955a.954.954 0 0 0 .2828.6795c.6994-.4107 1.5202-.6394 2.3818-.6394.9712 0 1.8655.2817 2.6065.7568a.955.955 0 0 0 .4268-.7968c0-.5275-.4261-.9551-.9517-.9551H13.43v-.0025l-.0001-.0093c-.0049-.5225-.4285-.9446-.9503-.9446-.5219 0-.9455.422-.9504.9446l-.0001.0093v.0025h-.9458zm2.5599 10.8162c-.2646.7336-.1038 1.6585-.1038 2.4207.0859.3014.3625.5221.6905.5221.4123 0 .7394-.3384.7394-.7208 0-.8704-.903-1.5218-1.3261-2.222zm-3.0953-6.6298c.4345-.8155 1.3159-1.3262 2.2886-1.3262 1.6826 0 2.9601 1.4815 2.6163 3.034l-.1091.4927.7975 1.3341h-.7124c-2.1443 0-3.8596 1.6238-3.8596 3.6537v2.2647L6.5465 15.636l3.5014-6.5712z"
  })];
};

exports.default = _default;